import { render } from "./RegisterForm.vue?vue&type=template&id=4598b0ad&scoped=true&ts=true"
import script from "./RegisterForm.vue?vue&type=script&lang=ts"
export * from "./RegisterForm.vue?vue&type=script&lang=ts"

import "./RegisterForm.vue?vue&type=style&index=0&id=4598b0ad&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4598b0ad"]])

export default __exports__